module.exports = __webpack_public_path__ + "static/media/bg-login.f18200de.jpg";